import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import API from "../api";

const Notificaciones = ({ solicitudes, actualizarSolicitudes }) => {
  const usuarioActivo = JSON.parse(sessionStorage.getItem("usuarioActivo"));
  const esAdmin = usuarioActivo?.RolUsuario === "Administrador";

  const solicitudesPendientes = solicitudes.filter((s) => s.Estado === "Pendiente");

  const cambiarEstado = async (solicitud, nuevoEstado) => {
    try {
      // 1. Cambiar estado en la solicitud
      await axios.put(`${API}/solicitudes_rrhh/${solicitud._id}`, {
        Estado: nuevoEstado,
        Responsable: usuarioActivo.Usuario,
      });

      // 2. Si se aprueba, generar documento
      if (nuevoEstado === "Aprobado") {
        const payload = {
          tipo: solicitud.TipoSolicitud,
          usuario: solicitud.Usuario,
          nombre_completo: `${solicitud.Nombre} ${solicitud["Apellido Paterno"]} ${solicitud["Apellido Materno"]}`,
          rut: solicitud.RUT || solicitud.Rut || solicitud.rut, // usa el campo que tengas
          cargo: solicitud.Cargo || "Cargo no especificado",
          empresa: "Mi Empresa S.A.",
          fechaInicio: solicitud.FechaInicio,
          fechaFin: solicitud.FechaFin,
          diasSolicitados: solicitud.DiasSolicitados || "N/A",
          fechaSolicitud: new Date().toLocaleDateString("es-CL"),
          aprobador: usuarioActivo.Usuario,
          aprobador_nombre: `${usuarioActivo.Nombre} ${usuarioActivo["Apellido Paterno"]}`,
        };

        const res = await axios.post(`${API}/generar_documento`, payload);
        console.log("Documento generado:", res.data);
      }

      actualizarSolicitudes(); // 🔄 recargar solicitudes
    } catch (err) {
      console.error("Error al actualizar solicitud:", err);
    }
  };


  if (!esAdmin) return <p className="text-danger">Solo los administradores pueden ver esta sección.</p>;

  return (
    <div className="p-4">
      {/* Ícono de campana con contador */}
      <div className="text-center mb-4">
        <div className="position-relative d-inline-block">
          <i className="bi bi-bell-fill fs-3 text-secondary"></i>
          {solicitudesPendientes.length > 0 && (
            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style={{ fontSize: "0.7rem" }}
            >
              {solicitudesPendientes.length}
            </span>
          )}
        </div>
        <h4 className="fw-bold mt-3">Solicitudes Pendientes</h4>
      </div>

      {solicitudesPendientes.length === 0 ? (
        <p className="text-muted text-center">No hay solicitudes pendientes.</p>
      ) : (
        <table className="table table-striped text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>Usuario</th>
              <th>Tipo</th>
              <th>Inicio</th>
              <th>Fin</th>
              <th>Comentario</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {solicitudesPendientes.map((s) => (
              <tr key={s._id}>
                <td>{s.Usuario}</td>
                <td>{s.TipoSolicitud}</td>
                <td>{s.FechaInicio}</td>
                <td>{s.FechaFin}</td>
                <td>{s.Comentario || "---"}</td>
                <td>
                  <Button
                    variant="success"
                    size="sm"
                    className="me-2"
                    onClick={() => cambiarEstado(s, "Aprobado")}
                  >
                    Aprobar
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => cambiarEstado(s, "Rechazado")}
                  >
                    Rechazar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Notificaciones;
